module.exports = __webpack_public_path__ + "img/提货派车.f07ca62f.svg";